<template>
  <el-dialog
    v-drag:common
    title="手动上传数据"
    :visible="visible"
    :show-close="false"
  >
    <el-form :model="formData" class="demo-form-inline">
      <el-form-item label="文件类型" label-width="80px">
        <el-select
          v-model="formData.type"
          placeholder="请选择文件类型"
          style="marginRight: 10px;"
        >
          <el-option
            v-for="item in dataFormatList"
            :key="item.value"
            :label="item.formatName"
            :value="item.extName"
          ></el-option>
        </el-select>
        <el-link
          underline
          v-if="!showPasswordByType && formData.type"
          :style="{
            borderBottom: '1px solid #606266;',
            fontSize: '12px'
          }"
          target="blank"
          :href="hrefUrl"
          download
        >
          {{ formData.type === 'txt' ? '示例文件' : '示例文件' }}
        </el-link>
      </el-form-item>
      <el-form-item label="数据文件" label-width="80px">
        <el-upload
          ref="upload"
          :action="action"
          :data="headers"
          :on-success="onFileUploadSuccess"
          accept=".csv, .rld, .txt, .rwd"
        >
          <ct-button type="primary">点击上传</ct-button>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="输入密码"
        v-if="showPasswordByType"
        label-width="80px"
        :fetch-suggestions="false"
      >
        <el-input
          v-model="formData.password"
          placeholder="请输入数字密码"
          type="password"
          style="width: 192px;"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <ct-button :btn-click="close" size="small" style="margin-right: 10px"
        >取 消</ct-button
      >
      <ct-button type="primary" :btn-click="submit" size="small"
        >确 定</ct-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils';
export default {
  props: ['visible'],
  data() {
    return {
      headers: {
        file: 'file',
        apiKey: getToken()
      },
      showPassword: false,
      formData: {
        type: '',
        password: ''
      },
      ids: [],
      modelNameKeyword: '',
      dataFormatList: [],
      action: `${process.env.VUE_APP_API_HOST_WINDDATA}/winddata/tower/uploadFile`
    };
  },
  computed: {
    showPasswordByType() {
      //console.log(this.formData.type, 'this.formData.type...');
      if (this.formData.type === 'rwd' || this.formData.type === 'rld')
        return true;
      return false;
    },
    hrefUrl() {
      return this.formData.type === 'txt'
        ? `${process.env.VUE_APP_TEMPLATE_HOST}/winddata/tower/getTemplateFile?fileName=tower.txt`
        : `${process.env.VUE_APP_TEMPLATE_HOST}/winddata/tower/getTemplateFile?fileName=tower.csv`;
    }
  },
  async mounted() {
    await this.getDataFormatList();
  },
  methods: {
    close() {
      this.formData = {
        type: '',
        password: ''
      };
      this.$refs.upload.clearFiles();
      this.$emit('close');
    },
    async submit() {
      if (!this.formData.type)
        return this.$message({
          message: '请选择文件类型',
          type: 'error'
        });
      if (this.showPasswordByType && !this.formData.password) {
        return this.$message({
          message: '请输入密码',
          type: 'error'
        });
      }
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (!numRe.test(this.formData.password)) {
        return this.$message({
          message: '密码必须为数字',
          type: 'error'
        });
      }
      await this.analysisFile(this.ids.join());
      this.formData = {
        type: '',
        password: ''
      };
      this.ids = [];
      this.$emit('close');
      this.$refs.upload.clearFiles();
      // this.$refs.upload.submit();
    },
    async analysisFile(id) {
      const { type, password = '' } = this.formData;
      await this.$fetch('/winddata/tower/checkParseFile', {
        module: 'windData',
        params: {
          fileIds: id,
          formatId: type,
          password
        },
        getRes: true
      }).then(async res => {
        if (res.code !== 2 && res.code !== 0) {
          return this.$message({
            type: 'error',
            message: res.message
          });
        }
        if (res.code === 2) {
          this.$confirm(res.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          })
            .then(() => {
              this.$postForm({
                url: '/winddata/tower/parseFile',
                module: 'windData',
                data: {
                  fileIds: id,
                  formatId: type,
                  password
                },
                showLoading: true,
                showError: true,
                showSuccess: true
              }).then(res => {
                if (res.code == 0) {
                  setTimeout(() => {
                    location.reload();
                  }, 1000);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消覆盖'
              });
              return;
            });
        }

        if (res.code === 0) {
          this.$postForm({
            url: '/winddata/tower/parseFile',
            module: 'windData',
            data: {
              fileIds: id,
              formatId: type,
              password
            },
            showLoading: true,
            showError: true,
            showSuccess: true
          }).then(res => {
            if (res.code == 0) {
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          });
        }
      });
    },
    async onFileUploadSuccess(response) {
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        const { files } = response.data;
        this.ids.push(
          files
            .map(item => {
              return item.fileId;
            })
            .join()
        );
        //console.log(this.ids, 'ids...');
        return;
      }
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    async getDataFormatList() {
      const { data } = await this.$fetch.get(
        '/winddata/tower/getDataFormatList',
        {
          module: 'windData'
        }
      );
      this.dataFormatList = data.dataFormatList;
    }
  }
};
</script>
<style lang="less" scoped></style>
